import { Box, Paper } from "@mui/material";
import { useThemeGreyBackgroundColor } from "hooks/useThemeGreyBackgroundColor";

import { FacilityHeaderV2 } from "./ProfileV2/FacilityHeaderV2";
import { TasksSection } from "./ProfileV2/TasksSection";

export const FacilityTasksV2: React.FC = () => {
  const greyBackgroundColor = useThemeGreyBackgroundColor();

  return (
    <Box sx={{ background: greyBackgroundColor }}>
      <FacilityHeaderV2 />

      <Paper elevation={1} sx={{ p: 3, m: 2 }}>
        <TasksSection />
      </Paper>
    </Box>
  );
};
